(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxRemoveNetworksFromQueue(
    NetworkListPOSTPaging, NetworkListService, $filter, toastr, $timeout, $http
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/printQueueProperties/settings/removeNetworkFromQueue/removeNetworkFromQueue.template.html',
      link: function(scope) {

        scope.networkListPaging = new NetworkListPOSTPaging();

        scope.list = [];
        scope.noItemSelected = true;
        scope.searchString = '';
        scope.selectedItems = [];
        scope.unselectedItems = [];
        scope.focusMe = false;
        var scrollEnd = null;
        var containerHeight = null;
        var customKeyBinding = false;
        var embed = '&embed=site';


        (function() {
          customKeyBinding = true;
          getFirstPage(makeArraOfIds());
          setFocus();
        })();

        function setFocus () {
          $timeout(function () {
            scope.focusMe = true;
          }, 300)
        }


        function makeArraOfIds () {
          var includes = [];
          if (Array.isArray(scope.context.printQueue.info._links['px:releaseFromOtherNetwork'])) {
            angular.forEach(scope.context.printQueue.info._links['px:releaseFromOtherNetwork'], function (network) {
              includes.push(network.href);
            })
          } else {
            if (scope.context.printQueue.info._links['px:releaseFromOtherNetwork']) {
              includes.push(scope.context.printQueue.info._links['px:releaseFromOtherNetwork'].href)
            }
          }
          return includes;
        }

        function getFirstPage (networkIds) {
          if (networkIds.length > 0) {
            scope.networkListPaging.pagingCriteria.networkIds = networkIds;
            scope.networkListPaging.pagingCriteria.pageSize = 10;
            scope.loadingPage = true;
            NetworkListService.getNetworkListPagedByPost(scope.networkListPaging, embed).then(function(response) {
              window.scrollTo(0,0);
              scope.totalPages = response.page.totalPages;
              scope.list = response.list
              scope.loadingPage = false;
            }).catch(function(error) {});
          }
        }

        scope.textSearch = function () {
          scope.networkListPaging.pagingCriteria.match = scope.searchString;
          getFirstPage();
        }

        function getNextPage () {
          if (!scope.loadingPage && scope.totalPages > scope.networkListPaging.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.networkListPaging.pagingCriteria.page += 1;
            NetworkListService.getNetworkListPagedByPost(scope.networkListPaging, embed).then(function(response){
              if (response.list) {
                scope.list = scope.list.concat(response.list);
              }
              scope.loadingPage = false;
            }).catch(function(error) {});
          }
        }

        angular.element('.pagination-content').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;

          if (!scope.loadingPage && scope.totalPages > scope.networkListPaging.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextPage();
              }, 300)
            }
          }
        });


        scope.toggleSelectItem = function (event, item) {
          event.stopPropagation()
          event.preventDefault()
          if (!item.options.isSelected) {
            item.options.isSelected = true
            scope.selectedItems.push(item);
          } else {
            item.options.isSelected = false
            deselectItem(item);
          }

          if (scope.selectedItems.length < 1) {
            scope.noItemSelected = true;
          } else {
            scope.noItemSelected = false;
          }
        }


        function deselectItem (item) {
          if (item.info) {
            for (var i = 0; i < scope.selectedItems.length; i++) {
              if (item.info._links.self.href === scope.selectedItems[i].info._links.self.href) {
                scope.selectedItems.splice(i, 1);
              }
            }
          } else {
            for (var i = 0; i < scope.unSelectedItems.length; i++) {
              if (item._links.self.href === scope.unSelectedItems[i]._links.self.href) {
                scope.unSelectedItems.splice(i, 1);
              }
            }
          }

        }

        document.onkeydown = function(evt) {
          evt = evt || window.event;
          if (customKeyBinding){
            switch (evt.keyCode) {
              case 38:
                evt.preventDefault();
                if (document.activeElement.previousElementSibling) {
                  document.activeElement.previousElementSibling.focus();
                }
              break;
              case 40:
                evt.preventDefault();
                if (document.activeElement.nextElementSibling) {
                  document.activeElement.nextElementSibling.focus();
                }
              break;
            }
          }
        };

        scope.closePopup = function () {
          scope.callback();
        }

        scope.saveChanges = function () {
          // addGroups();
          removeNetwork()
        }

        function removeNetwork (network) {
          // $rootScope.$broadcast('PRINT_QUEUE_SAVE_ENFORCED', scope.context.printQueue.info._links.self.href );

          var url = scope.context.printQueue.info._links['px:releaseFromOtherNetworks'].href;
          var itemIds = [];
          scope.selectedItems.forEach(function(item){
            itemIds.push(item.customProperties.id);
          })

          $http.delete(url, {
            headers: {
              "Content-Type": "application/json"
            },
            data: itemIds
          }).then(function(response) {
            toastr.success($filter('translate')('Deleted'))
            // removeItemFromList(network);
          }).catch(function(error) {
            console.log(error);
          });

          scope.callback();

        }

        scope.$on('$destroy', function() {
          angular.element('.pagination-content').off('scroll');
          customKeyBinding = false;
        });

      }
    };
  }

  pxRemoveNetworksFromQueue.$inject = ['NetworkListPOSTPaging', 'NetworkListService', '$filter', 'toastr', '$timeout', '$http'];

  angular
    .module('printix-admin')
    .directive('pxRemoveNetworksFromQueue', pxRemoveNetworksFromQueue);

})();
